import { useQuery } from "@tanstack/react-query";
import { apiRequest } from "@core/services/api/apiRequest";

export type UseFetchStaticPageArgs = {
  /** The slug of the static page to fetch */
  slug: string | undefined;
};

/**
 * Fetches a static page by slug.
 * React Query is the source of truth.
 *
 * @example
 * ```typescript
 * // In platform with react-router
 * const { slug } = useParams();
 * const { data, isLoading } = useFetchStaticPage({ slug });
 *
 * // Or with a known slug
 * const { data } = useFetchStaticPage({ slug: "privacy-policy" });
 * ```
 */
export function useFetchStaticPage({ slug }: UseFetchStaticPageArgs) {
  return useQuery({
    queryKey: ["staticPage", slug],
    queryFn: async function () {
      if (!slug) throw new Error("No slug provided");

      return await apiRequest(`/article/${slug}/`, "GET", null, false);
    },
    enabled: !!slug,
    retry: false,
  });
}

export default useFetchStaticPage;
